/**
 * Give stanbdar for reducers
 */
export const IDDLE = 'iddle'
export const REQUEST = 'request'
export const SUCCESS = 'success'
export const FAILURE = 'failure'
